import { isEmpty } from 'lodash';
import { strings } from '../../assets/strings/all';

export const verifyUserInputData = (profileData, fieldArray, contactData) => {
  const errors = {};
  const { errors: profileErrorString } = strings.profile;
  const { errors: authErrorString } = strings.auth;
  const { home } = strings;

  delete errors['email'];
  if (
    isEmpty(profileData.email) ||
    (profileData.email && profileData.email.trim() === '')
  ) {
    const error = authErrorString.email_required;
    errors['email'] = error;
  }

  delete errors['userTitle'];
  if (isEmpty(profileData.userTitle)) {
    const error = authErrorString.title_required;
    errors['userTitle'] = error;
  }

  delete errors['avatar'];
  if (
    isEmpty(profileData.avatar) ||
    (profileData.avatar && profileData.avatar.trim() === '')
  ) {
    const error = `${home.profile} ${authErrorString.is_required}`;
    errors['avatar'] = error;
  }

  delete errors['firstName'];
  if (
    isEmpty(profileData.firstName) ||
    (profileData.firstName && profileData.firstName.trim() === '')
  ) {
    const error = authErrorString.first_name_required;
    errors['firstName'] = error;
  }

  delete errors['lastName'];
  if (
    isEmpty(profileData.lastName) ||
    (profileData.lastName && profileData.lastName.trim() === '')
  ) {
    const error = authErrorString.last_name_required;
    errors['lastName'] = error;
  }

  // delete errors["phoneCode"];
  // if (isEmpty(profileData.phoneCode)) {
  //   const error = `${`Phone Code`} is Required`;
  //   errors["phoneCode"] = error;
  // }

  // delete errors["phoneNumber"];
  // if (isEmpty(profileData.phoneNumber)) {
  //   const error = `${`Phone Number`} is Required`;
  //   errors["phoneNumber"] = error;
  // }

  // delete errors['licenseId'];
  // if (
  //   isEmpty(profileData.licenseId) ||
  //   (profileData.association && profileData.association.trim() === '')
  // ) {
  //   const error = `${`License Id`} is Required`;
  //   errors['licenseId'] = error;
  // }

  delete errors['speciality'];
  if (isEmpty(profileData.speciality)) {
    const error = authErrorString.speciality_id_required;
    errors['speciality'] = error;
  }

  // delete errors['profession'];
  // if (isEmpty(profileData.profession)) {
  //   const error = `${`Profession`} is Required`;
  //   errors['profession'] = error;
  // }

  // delete errors['association'];
  // if (
  //   isEmpty(profileData.association) ||
  //   (profileData.association && profileData.association.trim() === '')
  // ) {
  //   const error = `${`Association`} is Required`;
  //   errors['association'] = error;
  // }

  delete errors['phoneCode'];
  if (!contactData.phoneCode) {
    errors['phoneCode'] = profileErrorString.no_phone_code;
  }

  delete errors['phoneNumber'];
  if (!contactData.phoneNumber) {
    errors['phoneNumber'] = profileErrorString.no_phone_number;
  } else {
    if (isEmpty(contactData.phoneNumber)) {
      errors['phoneNumber'] = profileErrorString.no_phone_number;
    }
    // if (contactData.phoneNumber === profileData.phoneNumber) {
    //   errors['phoneNumber'] = profileErrorString.same_phone_number;
    // }
  }

  // delete errors['about'];
  // if (
  //   isEmpty(profileData.about) ||
  //   (profileData.about && profileData.about.trim() === '')
  // ) {
  //   const error = `${`About`} is Required`;
  //   errors['about'] = error;
  // }
  return errors;
};
